import DatePicker from "react-datepicker";
import React, {useState, useEffect} from "react";
import queryString from "query-string";
import moment from "moment";
import history from "shared_history";
import { Button } from 'react-bootstrap';
import {flashMessages} from "ducks";
import {connect} from 'react-redux';
import PropTypes from "prop-types";

const MonthYearDateFilter = ({
  location, dispatch, maxMonthRange, defaultMonthRange, hideStartDate, defaultStartDate
}) => {
  const query = queryString.parse(location.search);
  const [startDate, setStartDate] = useState((!hideStartDate && query.start_date) ? moment(query.start_date).toDate() : defaultStartDate);
  const [endDate, setEndDate] = useState(query.end_date ? moment(query.end_date).toDate() : moment(startDate).add(defaultMonthRange, 'months').endOf('month').toDate());

  const updateUrl = () => {
    const monthsDiff = moment(endDate).endOf('month').diff(moment(startDate), 'months', true);
    if (maxMonthRange < 0 || monthsDiff <= maxMonthRange) {
      const searchParams = { ...query };
      if (!hideStartDate) {
        searchParams.start_date = moment(startDate).format('YYYY-MM-DD');
      }
      searchParams.end_date = moment(endDate).endOf('month').format('YYYY-MM-DD');

      history.push({
        ...location,
        search: `?${queryString.stringify(searchParams)}`
      });
    } else {
      dispatch(flashMessages.actions.show( {message: `Dates cannot exceed ${maxMonthRange} month period.`, type: 'danger', dismissible: true}))
    }
  };

  useEffect(() => {
    updateUrl()
    }, [])

  return (
    <div>
      { !hideStartDate && (
        <label className='date-filter-label'>
          Start Month
          <DatePicker
            dateFormat='MMM yyy'
            showMonthYearPicker
            className='input-small date-filter-input'
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            name='start_date'
            placeholder='Start Date'
          />
        </label>
      )}

      <label className='date-filter-label'>
        End Month
        <DatePicker
          dateFormat='MMM yyy'
          showMonthYearPicker
          className='input-small date-filter-input'
          selected={endDate}
          minDate={startDate}
          onChange={(date) => setEndDate(date)}
          name='end_date'
          placeholder='Start Date'
        />
      </label>

      <Button onClick={updateUrl}>Submit</Button>
    </div>
  );
};
MonthYearDateFilter.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string
  }).isRequired,
  // Default none
  maxMonthRange: PropTypes.number,
  defaultMonthRange: PropTypes.number,
  hideStartDate: PropTypes.bool,
  defaultStartDate: PropTypes.object
};
MonthYearDateFilter.defaultProps = {
  maxMonthRange: -1,
  defaultMonthRange: 0,
  hideStartDate: false,
  defaultStartDate: moment().startOf('month').toDate()
};


export default (connect()(MonthYearDateFilter));
